/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class BusinessUnitListDashboard {
    id:number;
    Name: string;
    code: string;
    active: boolean;
    status: string;
    createdAt: string;

    constructor(id:number, Name:string, code:string, active: boolean, status: string, createdAt: string){
        this.id = id;
        this.Name = Name;
        this.code = code;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/businessUnitManagement/businessUnitList-datatable/businessUnitList-dashboard.ts